// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import InvestorCategoryStepController from "./investor_category_step_controller";

application.register("investor-category-step", InvestorCategoryStepController);
